module.exports = __webpack_public_path__ + "static/moodboard-93a5c0b13cf636095917a7c4a3d76db9.mp4";